export default "__VITE_ASSET__Cc3io3jZ__"